<script setup lang="ts">
import { CheckCircleIcon, XCircleIcon } from '@heroicons/vue/24/solid';
const acceptedDocuments = [
  'Utility bill',
  'Lease or rental agreement',
  'Tax document',
  'Bank statement',
  'Confirmation of bank account',
];
const notAcceptedDocuments = [
  'Drivers licence',
  'Passport',
  'National ID',
  'Mobile phone statement',
];
</script>

<template>
  <div>
    <p class="mb-4 font-bold">Accepted document types</p>
    <div class="grid grid-cols-2">
      <ul role="list" class="col-span-2 md:col-span-1">
        <li
          v-for="docName in acceptedDocuments"
          :key="docName"
          class="mb-1 flex justify-between gap-x-6"
        >
          <div class="flex min-w-0 items-center gap-x-2">
            <CheckCircleIcon class="text-light-utility-green dark:text-dark-utility-green size-5" />
            <p class="text-light-utility-green dark:text-dark-utility-green text-base">
              {{ docName }}
            </p>
          </div>
        </li>
      </ul>

      <ul role="list" class="col-span-2 md:col-span-1">
        <li
          v-for="docName in notAcceptedDocuments"
          :key="docName"
          class="mb-1 flex justify-between gap-x-6"
        >
          <div class="flex min-w-0 items-center gap-x-2">
            <XCircleIcon class="text-dark-utility-red size-5" />
            <p class="text-dark-utility-red text-base">{{ docName }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
